import { LTSimpleAnimator } from "../../LTGame/Anim/LTSimpleAnimator";
import { AnimatorEx } from "../../LTGame/LTUtils/AnimatorEx";
import { LTUtils } from "../../LTGame/LTUtils/LTUtils";
import Vector3Ex from "../../LTGame/LTUtils/Vector3Ex";
import { P2Manager } from "../../LTGame/Physics/P2Manager";
import LTRes from "../../LTGame/Res/LTRes";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import LayerDefine from "../common/LayerDefine";
import ResDefine from "../common/ResDefine";
import AudioManager from "../manager/AudioManager";
import { EffectManager } from "../manager/EffectManager";
import MaterialManager from "../manager/MaterialManager";
import { UI_FightMediator } from "../ui/UI_FightMediator";
import HpItem from "./HpItem";
import AmmoBase from "./play/AmmoBase";
import ViewPlayer from "./play/ViewPlayer";
import { ELevelPoint } from "./ViewLevel";
export var EEnemyAnimIndex;
(function (EEnemyAnimIndex) {
    EEnemyAnimIndex[EEnemyAnimIndex["Idle_Normal"] = 0] = "Idle_Normal";
    EEnemyAnimIndex[EEnemyAnimIndex["Idle_Boss"] = 1] = "Idle_Boss";
    EEnemyAnimIndex[EEnemyAnimIndex["Idle_Self"] = 2] = "Idle_Self";
    EEnemyAnimIndex[EEnemyAnimIndex["Be_att"] = 3] = "Be_att";
    EEnemyAnimIndex[EEnemyAnimIndex["Dead"] = 4] = "Dead";
    EEnemyAnimIndex[EEnemyAnimIndex["Move"] = 5] = "Move";
})(EEnemyAnimIndex || (EEnemyAnimIndex = {}));
export var EEnemyState;
(function (EEnemyState) {
    EEnemyState[EEnemyState["Idle"] = 0] = "Idle";
    EEnemyState[EEnemyState["Move"] = 1] = "Move";
    EEnemyState[EEnemyState["Path"] = 2] = "Path";
    EEnemyState[EEnemyState["Dead"] = 3] = "Dead";
})(EEnemyState || (EEnemyState = {}));
/**
 * types 0=id 1=hp 2=前进方式 3目标类型 4奖励金币
 */
export default class ViewEenemy {
    constructor(point, config, types) {
        this.config = config;
        this.isEnabled = false;
        this.hp = types[1];
        this.roadType = types[2];
        this.enemyType = types[3];
        this.gold = types[4];
        this.pathIndex = 0;
        this.state = EEnemyState.Idle;
        this.CreateModel(point);
        this.CreateBody();
        this.SetState();
        // this.PlayAnim(EEnemyAnimIndex.Move);
    }
    CreateModel(point) {
        this.rootObj = LTRes.Get(ResDefine.FixPath(this.config.model_path));
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        this.rootObj.transform.position = point.transform.position;
        this.rootObj.transform.rotation = point.transform.rotation;
        // TransformEx.CopyTrans(this.rootObj.transform, point.transform);
        let anim = LTUtils.GetComponentsInChildren(this.rootObj, Laya.Animator)[0];
        this.bodyAnim = new LTSimpleAnimator(anim);
        this.bodyAnim.updateImd = true;
        this.hpItem = new HpItem(this, this.hp);
        this.render = LTUtils.FindChild(this.rootObj, this.config.skin);
    }
    SetState() {
        switch (this.state) {
            case EEnemyState.Idle:
                this.PlayIdle();
                break;
            case EEnemyState.Move:
                this.PlayAnim(EEnemyAnimIndex.Move);
                break;
            case EEnemyState.Path:
                this.PlayAnim(EEnemyAnimIndex.Be_att);
                break;
            case EEnemyState.Dead:
                this.PlayAnim(EEnemyAnimIndex.Dead);
                break;
        }
    }
    PlayIdle() {
        switch (this.enemyType) {
            case 1:
                this.PlayAnim(EEnemyAnimIndex.Idle_Normal);
                break;
            case 2:
                this.PlayAnim(EEnemyAnimIndex.Idle_Boss);
                break;
            case 3:
                this.PlayAnim(EEnemyAnimIndex.Idle_Self);
                break;
        }
    }
    PlayAnim(anim) {
        this.bodyAnim.targetAnimName = this.config.actors[anim];
    }
    CreateBody() {
        let obj = LTUtils.GetComponentsInChildren(this.rootObj, Laya.PhysicsCollider)[0];
        this.body = P2Manager.instance.CreateBody(obj.owner, LayerDefine.Enemy, LayerDefine.Player | LayerDefine.Ammo, p2.Body.DYNAMIC);
        this.body["use"] = this;
    }
    BeginContact(other) {
        if (!this.body.collisionResponse)
            return;
        if (other instanceof AmmoBase) {
            if (this.enemyType == 3)
                return;
            let damage = other.config.damage * GlobalUnit.game.player.GetSkill(2);
            this.UpdateHp(-damage);
            other.Destroy();
        }
        else if (other instanceof ViewPlayer) {
            if (this.enemyType == 3) {
                this.Destroy();
                GlobalUnit.game.player.AddMore(1);
            }
            else {
                if (!GlobalUnit.game.player.GetHaveSuper()) {
                    other.DoDie();
                }
                this.OnDie();
            }
        }
    }
    UpdateHp(value) {
        if (this.state == EEnemyState.Dead)
            return;
        this.hp += value;
        if (this.hp <= 0) {
            this.hp = 0;
            this.OnDie();
        }
        else {
            this.hpItem.UpdateBar(this.hp);
            this.OnHit();
        }
    }
    OnHit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.PlayAnim(EEnemyAnimIndex.Be_att);
            let white = MaterialManager.instance.GetEnemyWhite(this.config.id, this.render.skinnedMeshRenderer.sharedMaterial, false);
            this.render.skinnedMeshRenderer.sharedMaterial = white;
            yield AnimatorEx.WaitPlayEnd(this.bodyAnim.animators[0], null, 0.15);
            if (this.state == EEnemyState.Dead)
                return;
            let normal = MaterialManager.instance.GetEnemyWhite(this.config.id, this.render.skinnedMeshRenderer.sharedMaterial, true);
            this.render.skinnedMeshRenderer.sharedMaterial = normal;
            this.SetState();
        });
    }
    OnDie() {
        GameData.instance.coinCount += this.gold;
        UI_FightMediator.instance.RefreshUI();
        AudioManager.instance.PlayById(7);
        EffectManager.instance.PlayEffectById(7, 2, null, null, this.rootObj);
        this.body.collisionResponse = false;
        P2Manager.instance.RemoveBody(this.body);
        GlobalUnit.game.level.RemoveEnemy(this);
        this.hpItem.Destroy();
        let white = MaterialManager.instance.GetEnemyWhite(this.config.id, this.render.skinnedMeshRenderer.sharedMaterial, false);
        this.render.skinnedMeshRenderer.sharedMaterial = white;
        this.state = EEnemyState.Dead;
        this.SetState();
        this.isEnabled = false;
        Laya.timer.once(1000, this, () => {
            let old = this.rootObj.transform.localPositionY;
            Laya.Tween.to(this.rootObj.transform, { localPositionY: old - 1 }, 1000, null, Laya.Handler.create(this, () => {
                this.rootObj.destroy();
            }));
        });
    }
    Destroy() {
        this.body.collisionResponse = false;
        this.isEnabled = false;
        this.rootObj.destroy();
        P2Manager.instance.RemoveBody(this.body);
        GlobalUnit.game.level.RemoveEnemy(this);
        this.hpItem.Destroy();
    }
    CheckEnable() {
        if (this.roadType == 2)
            return;
        let pos = GlobalUnit.game.player.GetRootPos();
        let dist = pos.z - this.rootObj.transform.position.z;
        if (Math.abs(dist) <= this.config.dist) {
            this.isEnabled = true;
            P2Manager.instance.AddBody(this.body);
            if (this.roadType == 3) {
                this.state = EEnemyState.Move;
                this.SetState();
            }
        }
        if (Math.abs(dist) > this.config.dist * 2 || dist > this.config.dist) {
            this.rootObj.active = false;
        }
        else {
            this.rootObj.active = true;
        }
    }
    ActiveFighted() {
        if (this.roadType == 2) {
            P2Manager.instance.AddBody(this.body);
            this.isEnabled = true;
            this.state = EEnemyState.Move;
            this.SetState();
        }
    }
    SyncPos() {
        P2Manager.instance.SyncTransToRigXZ(this.rootObj.transform, this.body);
    }
    OnMove(dt) {
        if (this.pathIndex == 0) {
            let target = GlobalUnit.game.level.GetLevelPoint(ELevelPoint.Line);
            this.rootObj.transform.localPositionZ -= this.config.move_speed * dt;
            if (this.rootObj.transform.position.z < target.transform.position.z) {
                this.pathIndex = 1;
                console.log("change path", this.pathIndex);
                let target = GlobalUnit.game.level.GetLevelPoint(ELevelPoint.End);
                let vec3 = Vector3Ex.Subtract(target.transform.position, this.rootObj.transform.position);
                this.targetVec = Vector3Ex.Normalize(vec3);
                this.targetDist = Vector3Ex.Distance2D(Vector3Ex.s_zero, vec3);
            }
        }
        else if (this.pathIndex == 1) {
            let speed = this.config.move_speed * dt;
            let old = this.rootObj.transform.position;
            old.x += speed * this.targetVec.x;
            old.z += speed * this.targetVec.z;
            let yaw = Vector3Ex.SignAngleAsix(Vector3Ex.s_forward, this.targetVec, Vector3Ex.s_up);
            this.rootObj.transform.localRotationEulerY = yaw;
            this.targetDist -= speed;
            this.rootObj.transform.position = old;
            if (this.targetDist <= 0) {
                this.pathIndex = 2;
                console.log("change path", this.pathIndex);
            }
        }
        else {
            let old = this.rootObj.transform.position;
            if (!this.targetPlayer || this.targetPlayer.Dead) {
                let player = GlobalUnit.game.player.GetPlayerByDistance(old);
                if (!player) {
                    this.pathIndex = 3;
                    console.log("change path", this.pathIndex);
                    this.state = EEnemyState.Idle;
                    this.SetState();
                    return;
                }
                this.targetPlayer = player;
            }
            let vec3 = Vector3Ex.Subtract(this.targetPlayer.model.transform.position, old);
            vec3 = Vector3Ex.Normalize(vec3);
            let speed = this.config.move_speed * dt;
            old.x += vec3.x * speed;
            old.z += vec3.z * speed;
            this.rootObj.transform.position = old;
            let yaw = Vector3Ex.SignAngleAsix(Vector3Ex.s_forward, vec3, Vector3Ex.s_up);
            this.rootObj.transform.localRotationEulerY = yaw;
        }
    }
    MoveLine(dt) {
        this.rootObj.transform.localPositionZ -= this.config.move_speed * dt;
    }
    CheckDestroy() {
        let pos = GlobalUnit.game.player.GetRootPos();
        let dist = pos.z - this.rootObj.transform.position.z;
        if (dist >= 5) {
            this.Destroy();
            return;
        }
    }
    Update(dt) {
        if (this.state == EEnemyState.Dead)
            return;
        if (this.hpItem) {
            this.hpItem.SyncPos();
        }
        if (!this.isEnabled) {
            this.CheckEnable();
        }
        else {
            this.SyncPos();
            if (this.roadType == 2) {
                this.OnMove(dt);
            }
            else if (this.roadType == 3) {
                this.MoveLine(dt);
            }
            this.CheckDestroy();
        }
    }
}
